import { useSelector, useDispatch } from "react-redux";
import { resolutionList, resolutionListT } from "../../utils/constants";
import { getAspectRatio } from "../../redux/reducers/ui/uiSelectors";
import { setAspectRatio } from "../../redux/reducers/ui/uiReducer";
import s from "./Resolution.module.scss";
import { ResolutionDropdown } from "../../shared/ResolutionDropdown/ResolutionDropdown";

export const Resolution = () => {
  const dispatch = useDispatch();
  const resolution = useSelector(getAspectRatio) ?? resolutionList[0];
  const setResolution = (res: resolutionListT) => dispatch(setAspectRatio(res));

  return (
    <div className={s.wrapper}>
      <ResolutionDropdown resolution={resolution} setResolution={setResolution} />
    </div>
  );
};
